<template>
  <Dialog
    v-bind="$attrs"
    v-on="$listeners"
    :title="round ? locale.youGot : locale.noPrize"
    :hasDecor="false"
  >
    <!-- 刮刮乐奖励弹窗 -->
    <div v-if="round" class="award-box">
      <img class="award" src="~images/kv/award_4.png" />
      <span class="award-name">amazon card ${{ round }}</span>
    </div>
    <div v-else style="margin-bottom: 50px">{{ locale.sorry }}</div>
    <button data-type="button" class="dialog-btn" @click="close">
      <span>{{ locale.confirm }}</span>
    </button>
  </Dialog>
</template>

<script>
import Dialog from "./dlg.vue";

export default {
  name: "AwardDialog",
  props: {
    round: [Number, String],
  },
  components: {
    Dialog,
  },
  data() {
    return {
      locale: this.$locale.dialog.award,
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .dialog {
  &-content {
  }

  &-title {
    font-size: 32px;
  }

  &-body {
    height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    color: var(--primary-color);
    text-shadow: 1px 2px 0px rgba(57, 46, 32, 0.54),
      0px 0px 1px rgba(255, 233, 129, 0.69);
  }
}

.award-box {
  position: relative;
  width: 136px;
  height: 136px;
  margin-bottom: 80px;
  background: url(~images/kv/award_bg.png) no-repeat 0 0;
  background-size: 100% 100%;

  .award {
    position: absolute;
    top: 22px;
    left: 22px;
    width: 90px;
    height: 90px;
    object-fit: scale-down;
  }

  .award-name {
    position: absolute;
    top: 100%;
    left: 50%;
    width: 400px;
    transform: translateX(-50%);
    margin-top: 5px;
    font-size: 34px;
    color: #fff;
    text-align: center;
    text-shadow: 0px 0px 2px #000000, 0px 0px 7px rgba(0, 0, 0, 0.9);
  }
}
</style>
